import(/* webpackMode: "eager", webpackExports: ["V2ApplicationsScreen"] */ "/app/apps/platform-web/components/v2/screens/V2ApplicationsScreen.tsx");
